/**
 * @file   : Description.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/15/2019, 8:26:40 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import BoxContainer from '../../../external/components/container/BoxContainer'
import Cont from '../../../external/components/layout/Cont'
import Section from '../../../external/components/layout/Section'
import TextBlock from '../../../external/components/text/TextBlock'
import TextStyler, {
  GREY_TEXT,
} from '../../../external/components/text/TextStyler'
import { isEmpty } from '../../../external/utilities/GeneralUtils'
import { getTranslation } from '../InfoUtil'
import SectionAd from './SectionAd'
import SectionHeader from './SectionHeader'

const Description = ({ intl, theme, section, infoData, mainConfig }) => {
  const content = getTranslation(
    intl,
    section.token,
    section.default,
    infoData.infoToken,
  )
  if (!isEmpty(content) && section.showSection) {
    return (
      <Cont>
        <BoxContainer borderColor={'grey-medium'}>
          <SectionHeader intl={intl} section={section} infoData={infoData} />
          <Cont>
            <TextStyler styleObj={{ ...GREY_TEXT }}>
              <TextBlock isHTML isDefaultHTMLStyle content={content} />
            </TextStyler>
          </Cont>
        </BoxContainer>
        <SectionAd section={section} mainConfig={mainConfig} />
        <Section />
      </Cont>
    )
  }

  return null
}

Description.propTypes = {
  intl: PropTypes.object.isRequired,
  theme: PropTypes.string.isRequired,
  section: PropTypes.object,
  infoData: PropTypes.object,
  mainConfig: PropTypes.object,
}

export default Description
